import { Link } from "@mui/material";
import PropTypes from "prop-types";

const HyperLink = ({ url = "#", title, isOrderHyperlink = true, ...rest }) => {
  const linkUrl = isOrderHyperlink ? `/order-list/${title}` : url;

  /**
   * Prevent event getting passed to parent
   */
  const preventEventPropagation = (ev) => {
    ev.stopPropagation();
  };

  return (
    <Link
      href={title ? linkUrl : undefined}
      target={title ? "_blank" : undefined}
      underline="none"
      onClick={preventEventPropagation}
      sx={{
        pointerEvents: title ? "auto" : "none",
        cursor: title ? "pointer" : "default",
        ...rest,
      }}
    >
      {title || "-"}
    </Link>
  );
};

export default HyperLink;

HyperLink.propTypes = {
  title: PropTypes.string.isRequired,
  isOrderHyperlink: PropTypes.bool,
  url: PropTypes.string,
};
